export const subscriptionPricesUS = [
	{
		clearname: 'Max Amazon Channel',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 1825,
		provider_icon: 'max_amazon_channel.png',
	},
	{
		clearname: 'MGM Plus Amazon Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 583,
		provider_icon: 'mgm_plus_amazon_channel.png',
	},
	{
		clearname: 'Crunchyroll Amazon Channel',
		price: 7.99,
		free_trial: '7 Days Free',
		id: 1968,
		provider_icon: 'crunchyroll_amazon_channel.png',
	},
	{
		clearname: 'AMC Plus Apple TV Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 1854,
		provider_icon: 'amc_plus_apple_tv_channel.png',
	},
	{
		clearname: 'Paramount+ Amazon Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 582,
		provider_icon: 'paramount_plus_amazon_channel.png',
	},
	{
		clearname: 'Discovery+ Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 584,
		provider_icon: 'discovery_plus_amazon_channel.png',
	},
	{
		clearname: 'AMC+ Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 528,
		provider_icon: 'amc_plus_amazon_channel.png',
	},
	{
		clearname: 'Showtime Roku Premium Channel',
		price: 10.99,
		free_trial: '$4.99/month for 4 months',
		id: 632,
		provider_icon: 'showtime_roku_premium_channel.png',
	},
	{
		clearname: 'Paramount+ Roku Premium Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 633,
		provider_icon: 'paramount_plus_roku_premium_channel.png',
	},
	{
		clearname: 'Starz Roku Premium Channel',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 634,
		provider_icon: 'starz_roku_premium_channel.png',
	},
	{
		clearname: 'AMC+ Roku Premium Channel',
		price: 8.99,
		free_trial: '7 Days Free',
		id: 635,
		provider_icon: 'amc_plus_roku_premium_channel.png',
	},
	{
		clearname: 'Noggin Amazon Channel',
		price: 7.99,
		free_trial: '7 Days Free',
		id: 262,
		provider_icon: 'noggin_amazon_channel.png',
	},
	{
		clearname: 'Noggin Apple TV Channel',
		price: '',
		free_trial: '',
		id: 2032,
		provider_icon: 'noggin_apple_tv_channel.png',
	},
	{
		clearname: 'PBS Kids Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 293,
		provider_icon: 'pbs_kids_amazon_channel.png',
	},
	{
		clearname: 'Boomerang Amazon Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 288,
		provider_icon: 'boomerang_amazon_channel.png',
	},
	{
		clearname: 'Cinemax Amazon Channel',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 289,
		provider_icon: 'cinemax_amazon_channel.png',
	},
	{
		clearname: 'Cinemax Apple TV Channel',
		price: '',
		free_trial: '',
		id: 2061,
		provider_icon: 'cinemax_apple_tv_channel.png',
	},
	{
		clearname: 'Hallmark Movies Now Amazon Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 290,
		provider_icon: 'hallmark_movies_now_amazon_channel.png',
	},
	{
		clearname: 'PBS Masterpiece Amazon Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 294,
		provider_icon: 'pbs_masterpiece_amazon_channel.png',
	},
	{
		clearname: 'MZ Choice Amazon Channel',
		price: 7.99,
		free_trial: '7 Days Free',
		id: 291,
		provider_icon: 'mz_choice_amazon_channel.png',
	},
	{
		clearname: 'Shudder Amazon Channel',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 204,
		provider_icon: 'shudder_amazon_channel.png',
	},
	{
		clearname: 'MUBI Amazon Channel',
		price: 10.99,
		free_trial: '7 Days Free',
		id: 201,
		provider_icon: 'mubi_amazon_channel.png',
	},
	{
		clearname: 'AcornTV Amazon Channel',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 196,
		provider_icon: 'acorntv_amazon_channel.png',
	},
	{
		clearname: 'BritBox Amazon Channel',
		price: 8.99,
		free_trial: '7 Days Free',
		id: 197,
		provider_icon: 'britbox_amazon_channel.png',
	},
	{
		clearname: 'Fandor Amazon Channel',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 199,
		provider_icon: 'fandor_amazon_channel.png',
	},
	{
		clearname: 'Screambox Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 202,
		provider_icon: 'screambox_amazon_channel.png',
	},
	{
		clearname: 'Sundance Now Amazon Channel',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 205,
		provider_icon: 'sundance_now_amazon_channel.png',
	},
	{
		clearname: 'Bet+ Amazon Channel',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 343,
		provider_icon: 'bet_plus_amazon_channel.png',
	},
	{
		clearname: 'Bet+ Apple TV Channel',
		price: '',
		free_trial: '',
		id: 2040,
		provider_icon: 'bet_plus_apple_tv_channel.png',
	},
	{
		clearname: 'MGM Plus Roku Premium Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 636,
		provider_icon: 'mgm_plus_roku_premium_channel.png',
	},
	{
		clearname: 'Netflix Basic with Ads',
		price: 6.99,
		free_trial: '',
		id: 1796,
		provider_icon: 'netflix_basic_with_ads.png',
	},
	{
		clearname: 'AMC+',
		price: 8.99,
		free_trial: '',
		id: 526,
		provider_icon: 'amc+.png',
	},
	{
		clearname: 'Netflix',
		price: 15.49,
		free_trial: '',
		id: 8,
		provider_icon: 'netflix.png',
	},
	{
		clearname: 'Prime Video',
		price: 8.99,
		free_trial: '30 Days Free',
		id: 9,
		provider_icon: 'amazon_prime_video.png',
	},
	{
		clearname: 'Amazon Video',
		price: '',
		free_trial: '',
		id: 10,
		provider_icon: 'amazon_prime_video.png',
	},
	{
		clearname: 'Disney Plus',
		price: 7.99,
		free_trial: '',
		id: 337,
		provider_icon: 'disney_plus.png',
	},
	{
		clearname: 'Apple TV Plus',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 350,
		provider_icon: 'apple_tv_plus.png',
	},
	{
		clearname: 'Hulu',
		price: 7.99,
		free_trial: '',
		id: 15,
		provider_icon: 'hulu.png',
	},
	{
		clearname: 'Crunchyroll',
		price: 7.99,
		free_trial: '14 Days Free',
		id: 283,
		provider_icon: 'crunchyroll.png',
	},
	{
		clearname: 'fuboTV',
		price: 79.99,
		free_trial: '7 Days Free',
		id: 257,
		provider_icon: 'fubotv.png',
	},
	{
		clearname: 'Max',
		price: 15.99,
		free_trial: '',
		id: 1899,
		provider_icon: 'max.png',
	},
	{
		clearname: 'Peacock',
		price: 5.99,
		free_trial: '',
		id: 386,
		provider_icon: 'peacock.png',
	},
	{
		clearname: 'Peacock Premium',
		price: 11.99,
		free_trial: '',
		id: 387,
		provider_icon: 'peacock_premium.png',
	},
	{
		clearname: 'Kocowa',
		price: 6.99,
		free_trial: '14 Days Free',
		id: 464,
		provider_icon: 'kocowa.png',
	},
	{
		clearname: 'YouTube',
		price: 62.99,
		free_trial: '',
		id: 192,
		provider_icon: 'youtube.png',
	},
	{
		clearname: 'Paramount Plus',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 531,
		provider_icon: 'paramount_plus.png',
	},
	{
		clearname: 'Paramount+ with Showtime',
		price: 11.99,
		free_trial: '',
		id: 1770,
		provider_icon: 'paramount_plus_with_showtime.png',
	},
	{
		clearname: 'Funimation Now',
		price: 5.99,
		free_trial: '14 Days Free',
		id: 269,
		provider_icon: 'funimation_now.png',
	},
	{
		clearname: 'YouTube Premium',
		price: 7.99,
		free_trial: '30 Days Free',
		id: 188,
		provider_icon: 'youtube_premium.png',
	},
	{
		clearname: 'Starz',
		price: 9.99,
		free_trial: '206mo',
		id: 43,
		provider_icon: 'starz.png',
	},
	{
		clearname: 'Criterion Channel',
		price: 10.99,
		free_trial: '7 Days Free',
		id: 258,
		provider_icon: 'criterion_channel.png',
	},
	{
		clearname: 'Showtime',
		price: 11.99,
		free_trial: '7 Days Free',
		id: 37,
		provider_icon: 'showtime.png',
	},
	{
		clearname: 'DIRECTV',
		price: 69.99,
		free_trial: '5 Days Free',
		id: 358,
		provider_icon: 'directv.png',
	},
	{
		clearname: 'Fandor',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 25,
		provider_icon: 'fandor.png',
	},
	{
		clearname: 'Curiosity Stream',
		price: 4.99,
		free_trial: '',
		id: 190,
		provider_icon: 'curiosity_stream.png',
	},
	{
		clearname: 'MGM Plus',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 34,
		provider_icon: 'mgm_plus.png',
	},
	{
		clearname: 'Lifetime',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 157,
		provider_icon: 'lifetime.png',
	},
	{
		clearname: 'Shudder',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 99,
		provider_icon: 'shudder.png',
	},
	{
		clearname: 'Screambox',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 185,
		provider_icon: 'screambox.png',
	},
	{
		clearname: 'Acorn TV',
		price: 6.99,
		free_trial: '14 Days Free',
		id: 87,
		provider_icon: 'acorn_tv.png',
	},
	{
		clearname: 'Sundance Now',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 143,
		provider_icon: 'sundance_now.png',
	},
	{
		clearname: 'GuideDoc',
		price: 7.99,
		free_trial: '',
		id: 100,
		provider_icon: 'guidedoc.png',
	},
	{
		clearname: 'BritBox',
		price: 8.99,
		free_trial: '7 Days Free',
		id: 151,
		provider_icon: 'britbox.png',
	},
	{
		clearname: 'MUBI',
		price: 7.99,
		free_trial: '7 Days Free',
		id: 11,
		provider_icon: 'mubi.png',
	},
	{
		clearname: 'Boomerang',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 248,
		provider_icon: 'boomerang.png',
	},
	{
		clearname: 'History Vault',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 268,
		provider_icon: 'history_vault.png',
	},
	{
		clearname: 'Yupp TV',
		price: 9.99,
		free_trial: '14 Days Free',
		id: 255,
		provider_icon: 'yupp_tv.png',
	},
	{
		clearname: 'MyOutdoorTV',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 264,
		provider_icon: 'myoutdoortv.png',
	},
	{
		clearname: 'Magnolia Selects',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 259,
		provider_icon: 'magnolia_selects.png',
	},
	{
		clearname: 'Pure Flix',
		price: 7.99,
		free_trial: '7 Days Free',
		id: 278,
		provider_icon: 'pure_flix.png',
	},
	{
		clearname: 'Lifetime Movie Club',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 284,
		provider_icon: 'lifetime_movie_club.png',
	},
	{
		clearname: 'Sling TV Orange and Blue',
		price: '',
		free_trial: '',
		id: 299,
		provider_icon: 'sling_tv_orange_and_blue.png',
	},
	{
		clearname: 'HiDive',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 430,
		provider_icon: 'hidive.png',
	},
	{
		clearname: 'Night Flight Plus',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 455,
		provider_icon: 'night_flight_plus.png',
	},
	{
		clearname: 'Topic',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 454,
		provider_icon: 'topic.png',
	},
	{
		clearname: 'MTV',
		price: '',
		free_trial: '',
		id: 453,
		provider_icon: 'mtv.png',
	},
	{
		clearname: 'Retrocrush',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 446,
		provider_icon: 'retrocrush.png',
	},
	{
		clearname: 'Classix',
		price: 7.99,
		free_trial: '',
		id: 445,
		provider_icon: 'classix.png',
	},
	{
		clearname: 'Dekkoo',
		price: 9.99,
		free_trial: '3 Days Free',
		id: 444,
		provider_icon: 'dekkoo.png',
	},
	{
		clearname: 'Chai Flicks',
		price: 11.99,
		free_trial: '7 Days Free',
		id: 438,
		provider_icon: 'chai_flicks.png',
	},
	{
		clearname: 'OVID',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 433,
		provider_icon: 'ovid.png',
	},
	{
		clearname: 'Mhz Choice',
		price: 7.99,
		free_trial: '7 Days Free & 50% off',
		id: 427,
		provider_icon: 'mhz_choice.png',
	},
	{
		clearname: 'MZ Choice Amazon Channel',
		price: '',
		free_trial: '',
		id: 291,
		provider_icon: 'mhz_choice_amazon_channel.png',
	},
	{
		clearname: 'USA Network',
		price: 6.67,
		free_trial: '',
		id: 322,
		provider_icon: 'usa_network.png',
	},
	{
		clearname: 'FlixFling',
		price: 7.99,
		free_trial: '',
		id: 331,
		provider_icon: 'flixfling.png',
	},
	{
		clearname: 'Rakuten Viki',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 344,
		provider_icon: 'rakuten_viki.png',
	},
	{
		clearname: 'IndieFlix',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 368,
		provider_icon: 'indieflix.png',
	},
	{
		clearname: 'Motor Trend',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 410,
		provider_icon: 'motor_trend.png',
	},
	{
		clearname: 'Flix Premiere',
		price: 6.99,
		free_trial: '30 Days Free',
		id: 432,
		provider_icon: 'flix_premiere.png',
	},
	{
		clearname: 'AsianCrush',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 514,
		provider_icon: 'asiancrush.png',
	},
	{
		clearname: 'Rooster Teeth',
		price: 5.99,
		free_trial: '',
		id: 485,
		provider_icon: 'rooster_teeth.png',
	},
	{
		clearname: 'DOCSVILLE',
		price: 3.99,
		free_trial: '3 Days Free',
		id: 475,
		provider_icon: 'docsville.png',
	},
	{
		clearname: 'Hi-YAH',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 503,
		provider_icon: 'hi-yah.png',
	},
	{
		clearname: 'WeTV',
		price: 5.99,
		free_trial: '',
		id: 509,
		provider_icon: 'wetv.png',
	},
	{
		clearname: 'MLS Season Pass',
		price: '',
		free_trial: '',
		id: 1851,
		provider_icon: 'mls_season_pass.png',
	},
	{
		clearname: 'ARROW',
		price: 6.99,
		free_trial: '14 Days Free',
		id: 529,
		provider_icon: 'arrow.png',
	},
	{
		clearname: 'WOW Presents Plus',
		price: 4.99,
		free_trial: '',
		id: 546,
		provider_icon: 'wow_presents_plus.png',
	},
	{
		clearname: 'Magellan TV',
		price: 5.99,
		free_trial: '',
		id: 551,
		provider_icon: 'magellan_tv.png',
	},
	{
		clearname: 'BroadwayHD',
		price: 19.99,
		free_trial: '',
		id: 554,
		provider_icon: 'broadwayhd.png',
	},
	{
		clearname: 'True Story',
		price: 6.99,
		free_trial: '',
		id: 567,
		provider_icon: 'true_story.png',
	},
	{
		clearname: 'Martha Stewart TV',
		price: 6.99,
		free_trial: '14 Days Free',
		id: 568,
		provider_icon: 'martha_stewart_tv.png',
	},
	{
		clearname: 'DocAlliance Films',
		price: '',
		free_trial: '',
		id: 569,
		provider_icon: 'docalliance_films.png',
	},
	{
		clearname: 'Film Movement Plus',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 579,
		provider_icon: 'film_movement_plus.png',
	},
	{
		clearname: 'Metrograph',
		price: 5.0,
		free_trial: '',
		id: 585,
		provider_icon: 'metrograph.png',
	},
	{
		clearname: 'Cultpix',
		price: 6.66,
		free_trial: '',
		id: 692,
		provider_icon: 'cultpix.png',
	},
	{
		clearname: 'ShortsTV Amazon Channel',
		price: 1.99,
		free_trial: '7 Days Free',
		id: 688,
		provider_icon: 'shortstv_amazon_channel.png',
	},
	{
		clearname: 'ESPN',
		price: '',
		free_trial: '',
		id: 1718,
		provider_icon: 'espn.png',
	},
	{
		clearname: 'F1TV Pro',
		price: '',
		free_trial: '',
		id: 1720,
		provider_icon: 'f1tv_pro.png',
	},
	{
		clearname: 'Bet+',
		price: 5.99,
		free_trial: '',
		id: 1759,
		provider_icon: 'bet+.png',
	},
	{
		clearname: 'NFL Plus',
		price: 6.99,
		free_trial: '',
		id: 1760,
		provider_icon: 'nfl_plus.png',
	},
	{
		clearname: 'NBA League Pass',
		price: '',
		free_trial: '',
		id: 1761,
		provider_icon: 'nba_league_pass.png',
	},
	{
		clearname: 'ESPN 2',
		price: '',
		free_trial: '',
		id: 1765,
		provider_icon: 'espn_2.png',
	},
	{
		clearname: 'ESPN 3',
		price: '',
		free_trial: '',
		id: 1766,
		provider_icon: 'espn_3.png',
	},
	{
		clearname: 'ESPN Deportes',
		price: '',
		free_trial: '',
		id: 1767,
		provider_icon: 'espn_deportes.png',
	},
	{
		clearname: 'ESPN Plus',
		price: '',
		free_trial: '',
		id: 1768,
		provider_icon: 'espn_plus.png',
	},
	{
		clearname: 'MLB TV',
		price: '',
		free_trial: '',
		id: 1769,
		provider_icon: 'mlb_tv.png',
	},
	{
		clearname: 'Tennis Channel',
		price: '',
		free_trial: '',
		id: 1774,
		provider_icon: 'tennis_channel.png',
	},
	{
		clearname: 'Fox Sports 1',
		price: '',
		free_trial: '',
		id: 1776,
		provider_icon: 'fox_sports_1.png',
	},
	{
		clearname: 'DAZN',
		price: '',
		free_trial: '',
		id: 695,
		provider_icon: 'dazn.png',
	},
	{
		clearname: 'NHL Network',
		price: '',
		free_trial: '',
		id: 1786,
		provider_icon: 'nhl_network.png',
	},
	{
		clearname: 'Twitch',
		price: '',
		free_trial: '',
		id: 1785,
		provider_icon: 'twitch.png',
	},
	{
		clearname: 'Klassiki',
		price: 10.99,
		free_trial: '7 Days Free',
		id: 1793,
		provider_icon: 'klassiki.png',
	},
	{
		clearname: 'Starz Amazon Channel',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 1794,
		provider_icon: 'starz_amazon_channel.png',
	},
	{
		clearname: 'Fox Sports',
		price: '',
		free_trial: '',
		id: 1799,
		provider_icon: 'fox_sports.png',
	},
	{
		clearname: 'Sling TV Orange',
		price: '',
		free_trial: '',
		id: 1809,
		provider_icon: 'sling_tv_orange.png',
	},
	{
		clearname: 'Sling TV Blue',
		price: '',
		free_trial: '',
		id: 1810,
		provider_icon: 'sling_tv_blue.png',
	},
	{
		clearname: 'Cohen Media Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 1811,
		provider_icon: 'cohen_media_amazon_channel.png',
	},
	{
		clearname: 'Flo Rugby',
		price: '',
		free_trial: '',
		id: 1824,
		provider_icon: 'flo_rugby.png',
	},
	{
		clearname: 'Popflick',
		price: 6.99,
		free_trial: '5 Free Movies or Episodes per Month',
		id: 1832,
		provider_icon: 'popflick.png',
	},
	{
		clearname: 'Courtside 1891',
		price: '',
		free_trial: '',
		id: 1763,
		provider_icon: 'courtside_1891.png',
	},
	{
		clearname: 'FOX Soccer Plus',
		price: '',
		free_trial: '',
		id: 1848,
		provider_icon: 'fox_soccer_plus.png',
	},
	{
		clearname: 'Viaplay',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 76,
		provider_icon: 'viaplay.png',
	},
	{
		clearname: 'Tennis TV',
		price: '',
		free_trial: '',
		id: 1863,
		provider_icon: 'tennis_tv.png',
	},
	{
		clearname: 'ViX Premium Amazon Channel',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 1866,
		provider_icon: 'vix_premium_amazon_channel.png',
	},
	{
		clearname: 'MLB.TV Amazon Channel',
		price: '',
		free_trial: '',
		id: 1867,
		provider_icon: 'mlb_tv_amazon_channel.png',
	},
	{
		clearname: 'NBA TV Amazon Channel',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 1868,
		provider_icon: 'nba_tv_amazon_channel.png',
	},
	{
		clearname: 'NBA League Pass Amazon Channel',
		price: '',
		free_trial: '',
		id: 1869,
		provider_icon: 'nba_league_pass_amazon_channel.png',
	},
	{
		clearname: 'MLB Network',
		price: '',
		free_trial: '',
		id: 1877,
		provider_icon: 'mlb_network.png',
	},
	{
		clearname: 'Sling TV Sports Extras',
		price: 11.0,
		free_trial: '',
		id: 1878,
		provider_icon: 'sling_tv_sports_extras.png',
	},
	{
		clearname: 'Bally Sports',
		price: 19.99,
		free_trial: '',
		id: 1911,
		provider_icon: 'bally_sports.png',
	},
	{
		clearname: 'beIN SPORTS',
		price: '',
		free_trial: '',
		id: 1751,
		provider_icon: 'bein_sports.png',
	},
	{
		clearname: 'Fox Sports 2',
		price: '',
		free_trial: '',
		id: 1921,
		provider_icon: 'fox_sports_2.png',
	},
	{
		clearname: 'WILLOW',
		price: '',
		free_trial: '',
		id: 1918,
		provider_icon: 'willow.png',
	},
	{
		clearname: 'Discovery+',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 520,
		provider_icon: 'discovery+.png',
	},
	{
		clearname: 'NFL Sunday Ticket',
		price: '',
		free_trial: '',
		id: 1947,
		provider_icon: 'nfl_sunday_ticket.png',
	},
	{
		clearname: 'FilmStruck',
		price: '',
		free_trial: '',
		id: 102,
		provider_icon: 'filmstruck.png',
	},
	{
		clearname: 'BR Sports',
		price: '',
		free_trial: '',
		id: 1955,
		provider_icon: 'br_sports.png',
	},
	{
		clearname: 'Cineverse',
		price: 4.99,
		free_trial: 'Free with Ads',
		id: 1957,
		provider_icon: 'cineverse.png',
	},
	{
		clearname: 'Midnight Pulp',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 1960,
		provider_icon: 'midnight_pulp.png',
	},
	{
		clearname: 'Shahid VIP',
		price: 8.99,
		free_trial: '7 Days Free',
		id: 1715,
		provider_icon: 'shahid_vip.png',
	},
	{
		clearname: 'Fanatiz',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 1979,
		provider_icon: 'fanatiz.png',
	},
	{
		clearname: 'NBA League Pass on YouTube TV',
		price: '',
		free_trial: '',
		id: 1980,
		provider_icon: 'nba_league_pass_on_youtube_tv.png',
	},
	{
		clearname: 'Full Moon Amazon Channel',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 597,
		provider_icon: 'full_moon_amazon_channel.png',
	},
	{
		clearname: 'Google Play Movies',
		price: '',
		free_trial: '',
		id: 3,
		provider_icon: 'google_play_movies.png',
	},
	{
		clearname: 'Vudu',
		price: '',
		free_trial: '',
		id: 7,
		provider_icon: 'vudu.png',
	},
	{
		clearname: 'Fandango',
		price: '',
		free_trial: '',
		id: 60,
		provider_icon: 'fandango.png',
	},
	{
		clearname: 'Microsoft Store',
		price: '',
		free_trial: '',
		id: 68,
		provider_icon: 'microsoft_store.png',
	},
	{
		clearname: 'Tubi TV',
		price: '',
		free_trial: '',
		id: 73,
		provider_icon: 'tubi_tv.png',
	},
	{
		clearname: 'The CW',
		price: '',
		free_trial: '',
		id: 83,
		provider_icon: 'the_cw.png',
	},
	{
		clearname: 'AMC Theatres',
		price: '',
		free_trial: '',
		id: 162,
		provider_icon: 'amc_theatres.png',
	},
	{
		clearname: 'Pantaflix',
		price: '',
		free_trial: '',
		id: 177,
		provider_icon: 'pantaflix.png',
	},
	{
		clearname: 'Atom Tickets',
		price: '',
		free_trial: '',
		id: 179,
		provider_icon: 'atom_tickets.png',
	},
	{
		clearname: 'CW Seed',
		price: '',
		free_trial: '',
		id: 206,
		provider_icon: 'cw_seed.png',
	},
	{
		clearname: 'The Roku Channel',
		price: '',
		free_trial: '',
		id: 207,
		provider_icon: 'the_roku_channel.png',
	},
	{
		clearname: 'YouTube Free',
		price: '',
		free_trial: '',
		id: 235,
		provider_icon: 'youtube_free.png',
	},
	{
		clearname: 'Popcornflix',
		price: '',
		free_trial: '',
		id: 241,
		provider_icon: 'popcornflix.png',
	},
	{
		clearname: 'Laugh Out Loud',
		price: '',
		free_trial: '',
		id: 275,
		provider_icon: 'laugh_out_loud.png',
	},
	{
		clearname: 'Redbox',
		price: '',
		free_trial: '',
		id: 279,
		provider_icon: 'redbox.png',
	},
	{
		clearname: 'Pluto TV',
		price: '',
		free_trial: '',
		id: 300,
		provider_icon: 'pluto_tv.png',
	},
	{
		clearname: 'Hoichoi',
		price: '',
		free_trial: '',
		id: 315,
		provider_icon: 'hoichoi.png',
	},
	{
		clearname: 'VUDU Free',
		price: '',
		free_trial: '',
		id: 332,
		provider_icon: 'vudu_free.png',
	},
	{
		clearname: 'AMC on Demand',
		price: '',
		free_trial: '',
		id: 352,
		provider_icon: 'amc_on_demand.png',
	},
	{
		clearname: 'Here TV',
		price: '',
		free_trial: '',
		id: 417,
		provider_icon: 'here_tv.png',
	},
	{
		clearname: 'Apple TV',
		price: '',
		free_trial: '',
		id: 2,
		provider_icon: 'apple_tv.png',
	},
	{
		clearname: 'Dogwoof On Demand',
		price: '',
		free_trial: '',
		id: 536,
		provider_icon: 'dogwoof_on_demand.png',
	},
	{
		clearname: 'Kino Now',
		price: '',
		free_trial: '',
		id: 640,
		provider_icon: 'kino_now.png',
	},
	{
		clearname: 'Takflix',
		price: '',
		free_trial: '',
		id: 1771,
		provider_icon: 'takflix.png',
	},
	{
		clearname: 'Cinemark',
		price: '',
		free_trial: '',
		id: 1975,
		provider_icon: 'cinemark.png',
	},
	{
		clearname: 'Cinepolis USA',
		price: '',
		free_trial: '',
		id: 1978,
		provider_icon: 'cinepolis_usa.png',
	},
	{
		clearname: 'Plex',
		price: '',
		free_trial: '',
		id: 538,
		provider_icon: 'plex.png',
	},
	{
		clearname: 'Plex Live TV',
		price: '',
		free_trial: '',
		id: 1922,
		provider_icon: 'plex_live_tv.png',
	},
	{
		clearname: 'FYI Network',
		price: '',
		free_trial: '',
		id: 1962,
		provider_icon: 'fyi_network.png',
	},
	{
		clearname: 'Freevee',
		price: '',
		free_trial: '',
		id: 613,
		provider_icon: 'freevee.png',
	},
	{
		clearname: 'KoreaOnDemand',
		price: '',
		free_trial: '',
		id: 575,
		provider_icon: 'koreaondemand.png',
	},
	{
		clearname: 'Eventive',
		price: '',
		free_trial: '',
		id: 677,
		provider_icon: 'eventive.png',
	},
	{
		clearname: 'FILMRISE',
		price: '',
		free_trial: '',
		id: 471,
		provider_icon: 'filmrise.png',
	},
	{
		clearname: 'MovieSaints',
		price: '',
		free_trial: '',
		id: 562,
		provider_icon: 'moviesaints.png',
	},
	{
		clearname: 'Ovation TV',
		price: '',
		free_trial: '',
		id: 1953,
		provider_icon: 'ovation_tv.png',
	},
	{
		clearname: 'Public Domain Movies',
		price: '',
		free_trial: '',
		id: 638,
		provider_icon: 'public_domain_movies.png',
	},
	{
		clearname: 'Reveel',
		price: '',
		free_trial: '',
		id: 1948,
		provider_icon: 'reveel.png',
	},
	{
		clearname: 'myfilmfriend',
		price: '',
		free_trial: '',
		id: 1972,
		provider_icon: 'myfilmfriend.png',
	},
	{
		clearname: 'Spamflix',
		price: '',
		free_trial: '',
		id: 521,
		provider_icon: 'spamflix.png',
	},
	{
		clearname: 'Paramount Plus Apple TV Channel',
		price: '',
		free_trial: '',
		id: 1853,
		provider_icon: 'paramount_plus_apple_tv_channel.png',
	},
	{
		clearname: 'Starz Apple TV Channel',
		price: '',
		free_trial: '',
		id: 1855,
		provider_icon: 'starz_apple_tv_channel.png',
	},
	{
		clearname: 'Britbox Apple TV Channel',
		price: '',
		free_trial: '',
		id: 1852,
		provider_icon: 'britbox_apple_tv_channel.png',
	},
	{
		clearname: 'Starz Play Amazon Channel',
		price: '',
		free_trial: '',
		id: 194,
		provider_icon: 'starz_play_amazon_channel.png',
	},
	{
		clearname: 'Showtime Amazon Channel',
		price: '',
		free_trial: '',
		id: 203,
		provider_icon: 'showtime_amazon_channel.png',
	},
	{
		clearname: 'Showtime Apple TV Channel',
		price: '',
		free_trial: '',
		id: 675,
		provider_icon: 'showtime_apple_tv_channel.png',
	},
	{
		clearname: 'Hoopla',
		price: '',
		free_trial: '',
		id: 212,
		provider_icon: 'hoopla.png',
	},
	{
		clearname: 'PBS',
		price: '',
		free_trial: '',
		id: 209,
		provider_icon: 'pbs.png',
	},
	{
		clearname: 'FXNow',
		price: '',
		free_trial: '',
		id: 123,
		provider_icon: 'fxnow.png',
	},
	{
		clearname: 'Kanopy',
		price: '',
		free_trial: '',
		id: 191,
		provider_icon: 'kanopy.png',
	},
	{
		clearname: 'Comedy Central',
		price: '',
		free_trial: '',
		id: 243,
		provider_icon: 'comedy_central.png',
	},
	{
		clearname: 'Sun Nxt',
		price: 4.69,
		free_trial: '',
		id: 309,
		provider_icon: 'sun_nxt.png',
	},
	{
		clearname: 'ABC',
		price: '',
		free_trial: '',
		id: 148,
		provider_icon: 'abc.png',
	},
	{
		clearname: 'Crackle',
		price: '',
		free_trial: '',
		id: 12,
		provider_icon: 'crackle.png',
	},
	{
		clearname: 'AMC',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 80,
		provider_icon: 'amc.png',
	},
	{
		clearname: 'NBC',
		price: '',
		free_trial: '',
		id: 79,
		provider_icon: 'nbc.png',
	},
	{
		clearname: 'Freeform',
		price: '',
		free_trial: '',
		id: 211,
		provider_icon: 'freeform.png',
	},
	{
		clearname: 'History',
		price: '',
		free_trial: '',
		id: 155,
		provider_icon: 'history.png',
	},
	{
		clearname: 'A&E',
		price: '',
		free_trial: '',
		id: 156,
		provider_icon: 'a&e.png',
	},
	{
		clearname: 'Syfy',
		price: '',
		free_trial: '',
		id: 215,
		provider_icon: 'syfy.png',
	},
	{
		clearname: 'realeyz',
		price: '',
		free_trial: '',
		id: 14,
		provider_icon: 'realeyz.png',
	},
	{
		clearname: 'Netflix Kids',
		price: '',
		free_trial: '',
		id: 175,
		provider_icon: 'netflix_kids.png',
	},
	{
		clearname: 'Urban Movie Channel',
		price: 4.99,
		free_trial: '',
		id: 251,
		provider_icon: 'urban_movie_channel.png',
	},
	{
		clearname: 'Eros Now',
		price: '',
		free_trial: '',
		id: 218,
		provider_icon: 'eros_now.png',
	},
	{
		clearname: 'WWE Network',
		price: '',
		free_trial: '',
		id: 260,
		provider_icon: 'wwe_network.png',
	},
	{
		clearname: 'Hopster TV',
		price: 5.99,
		free_trial: '',
		id: 267,
		provider_icon: 'hopster_tv.png',
	},
	{
		clearname: 'Smithsonian Channel',
		price: '',
		free_trial: '',
		id: 276,
		provider_icon: 'smithsonian_channel.png',
	},
	{
		clearname: 'Viewster Amazon Channel',
		price: '',
		free_trial: '',
		id: 295,
		provider_icon: 'viewster_amazon_channel.png',
	},
	{
		clearname: 'VIX',
		price: 6.99,
		free_trial: '',
		id: 457,
		provider_icon: 'vix.png',
	},
	{
		clearname: 'Cartoon Network',
		price: '',
		free_trial: '',
		id: 317,
		provider_icon: 'cartoon_network.png',
	},
	{
		clearname: 'Adult Swim',
		price: '',
		free_trial: '',
		id: 318,
		provider_icon: 'adult_swim.png',
	},
	{
		clearname: 'Fox',
		price: '',
		free_trial: '',
		id: 328,
		provider_icon: 'fox.png',
	},
	{
		clearname: 'TCM',
		price: '',
		free_trial: '',
		id: 361,
		provider_icon: 'tcm.png',
	},
	{
		clearname: 'Bravo TV',
		price: '',
		free_trial: '',
		id: 365,
		provider_icon: 'bravo_tv.png',
	},
	{
		clearname: 'TNT',
		price: '',
		free_trial: '',
		id: 363,
		provider_icon: 'tnt.png',
	},
	{
		clearname: 'Food Network',
		price: '',
		free_trial: '',
		id: 366,
		provider_icon: 'food_network.png',
	},
	{
		clearname: 'BBC America',
		price: '',
		free_trial: '',
		id: 397,
		provider_icon: 'bbc_america.png',
	},
	{
		clearname: 'TLC',
		price: '',
		free_trial: '',
		id: 412,
		provider_icon: 'tlc.png',
	},
	{
		clearname: 'AHCTV',
		price: '',
		free_trial: '',
		id: 398,
		provider_icon: 'ahctv.png',
	},
	{
		clearname: 'HGTV',
		price: '',
		free_trial: '',
		id: 406,
		provider_icon: 'hgtv.png',
	},
	{
		clearname: 'DIY Network',
		price: '',
		free_trial: '',
		id: 405,
		provider_icon: 'diy_network.png',
	},
	{
		clearname: 'Investigation Discovery',
		price: '',
		free_trial: '',
		id: 408,
		provider_icon: 'investigation_discovery.png',
	},
	{
		clearname: 'Science Channel',
		price: '',
		free_trial: '',
		id: 411,
		provider_icon: 'science_channel.png',
	},
	{
		clearname: 'Destination America',
		price: '',
		free_trial: '',
		id: 402,
		provider_icon: 'destination_america.png',
	},
	{
		clearname: 'Discovery Life',
		price: '',
		free_trial: '',
		id: 404,
		provider_icon: 'discovery_life.png',
	},
	{
		clearname: 'Animal Planet',
		price: '',
		free_trial: '',
		id: 399,
		provider_icon: 'animal_planet.png',
	},
	{
		clearname: 'Discovery',
		price: '',
		free_trial: '',
		id: 403,
		provider_icon: 'discovery.png',
	},
	{
		clearname: 'Travel Channel',
		price: '',
		free_trial: '',
		id: 413,
		provider_icon: 'travel_channel.png',
	},
	{
		clearname: 'Cooking Channel',
		price: '',
		free_trial: '',
		id: 400,
		provider_icon: 'cooking_channel.png',
	},
	{
		clearname: 'Paramount Network',
		price: '',
		free_trial: '',
		id: 418,
		provider_icon: 'paramount_network.png',
	},
	{
		clearname: 'TV Land',
		price: '',
		free_trial: '',
		id: 419,
		provider_icon: 'tv_land.png',
	},
	{
		clearname: 'Logo TV',
		price: '',
		free_trial: '',
		id: 420,
		provider_icon: 'logo_tv.png',
	},
	{
		clearname: 'VH1',
		price: '',
		free_trial: '',
		id: 422,
		provider_icon: 'vh1.png',
	},
	{
		clearname: 'DreamWorksTV Amazon Channel',
		price: '',
		free_trial: '',
		id: 263,
		provider_icon: 'dreamworkstv_amazon_channel.png',
	},
	{
		clearname: 'TBS',
		price: '',
		free_trial: '',
		id: 506,
		provider_icon: 'tbs.png',
	},
	{
		clearname: 'Revry',
		price: '',
		free_trial: '',
		id: 473,
		provider_icon: 'revry.png',
	},
	{
		clearname: 'OXYGEN',
		price: '',
		free_trial: '',
		id: 487,
		provider_icon: 'oxygen.png',
	},
	{
		clearname: 'Spectrum On Demand',
		price: '',
		free_trial: '',
		id: 486,
		provider_icon: 'spectrum_on_demand.png',
	},
	{
		clearname: 'tru TV',
		price: '',
		free_trial: '',
		id: 507,
		provider_icon: 'tru_tv.png',
	},
	{
		clearname: 'DisneyNOW',
		price: '',
		free_trial: '',
		id: 508,
		provider_icon: 'disneynow.png',
	},
	{
		clearname: 'The Oprah Winfrey Network',
		price: '',
		free_trial: '',
		id: 555,
		provider_icon: 'the_oprah_winfrey_network.png',
	},
	{
		clearname: 'iQIYI',
		price: '',
		free_trial: '',
		id: 581,
		provider_icon: 'iqiyi.png',
	},
	{
		clearname: 'FilmBox Plus',
		price: 0.99,
		free_trial: '7 Days Free',
		id: 701,
		provider_icon: 'filmbox_plus.png',
	},
	{
		clearname: 'aha',
		price: 7.99,
		free_trial: '',
		id: 532,
		provider_icon: 'aha.png',
	},
	{
		clearname: 'Telemundo',
		price: '',
		free_trial: '',
		id: 1930,
		provider_icon: 'telemundo.png',
	},
	{
		clearname: 'Univer Video',
		price: '',
		free_trial: '',
		id: 1860,
		provider_icon: 'univer_video.png',
	},
	{
		clearname: 'Xumo Play',
		price: '',
		free_trial: '',
		id: 1963,
		provider_icon: 'xumo_play.png',
	},
];

export const subscriptionPricesUK = [
	{
		clearname: 'Netflix',
		price: 10.99,
		free_trial: '',
		id: 8,
		provider_icon: 'netflix.png',
	},
	{
		clearname: 'Disney Plus',
		price: 7.99,
		free_trial: '',
		id: 337,
		provider_icon: 'disney_plus.png',
	},
	{
		clearname: 'Prime Video',
		price: 8.99,
		free_trial: '30 Days Free',
		id: 9,
		provider_icon: 'amazon_prime_video.png',
	},
	{
		clearname: 'Amazon Video',
		price: '',
		free_trial: '',
		id: 10,
		provider_icon: 'amazon_prime_video.png',
	},
	{
		clearname: 'Google Play Movies',
		price: '',
		free_trial: '',
		id: 3,
		provider_icon: 'google_play_movies.png',
	},
	{
		clearname: 'Apple TV Plus',
		price: 8.99,
		free_trial: '7 Days Free',
		id: 350,
		provider_icon: 'apple_tv_plus.png',
	},
	{
		clearname: 'Apple TV',
		price: '',
		free_trial: '',
		id: 2,
		provider_icon: 'apple_tv.png',
	},
	{
		clearname: 'Microsoft Store',
		price: '',
		free_trial: '',
		id: 68,
		provider_icon: 'microsoft_store.png',
	},
	{
		clearname: 'Crunchyroll',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 283,
		provider_icon: 'crunchyroll.png',
	},
	{
		clearname: 'Paramount Plus',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 531,
		provider_icon: 'paramount_plus.png',
	},
	{
		clearname: 'Channel 4',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 103,
		provider_icon: 'paramount_plus.png',
	},
	{
		clearname: 'Sky Go',
		price: 14.0,
		free_trial: '7 Days Free',
		id: 29,
		provider_icon: 'sky_go.png',
	},
	{
		clearname: 'Crunchyroll Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 1968,
		provider_icon: 'crunchyroll_amazon_channel.png',
	},
	{
		clearname: 'BBC iPlayer',
		price: '',
		free_trial: '',
		id: 38,
		provider_icon: 'bbc_iplayer.png',
	},
	{
		clearname: 'MUBI',
		price: 11.99,
		free_trial: '7 Days Free',
		id: 11,
		provider_icon: 'mubi.png',
	},
	{
		clearname: 'BFI Player',
		price: 4.99,
		free_trial: '',
		id: 224,
		provider_icon: 'bfi_player.png',
	},
	{
		clearname: 'Curzon Home Cinema',
		price: 6.99,
		free_trial: '',
		id: 189,
		provider_icon: 'curzon_home_cinema.png',
	},
	{
		clearname: 'Funimation Now',
		price: '',
		free_trial: '',
		id: 269,
		provider_icon: 'funimation_now.png',
	},
	{
		clearname: 'ITVX',
		price: 5.99,
		free_trial: '',
		id: 41,
		provider_icon: 'itvx.png',
	},
	{
		clearname: 'YouTube',
		price: 11.99,
		free_trial: '',
		id: 192,
		provider_icon: 'youtube.png',
	},
	{
		clearname: 'Shudder',
		price: 4.99,
		free_trial: '',
		id: 99,
		provider_icon: 'shudder.png',
	},
	{
		clearname: 'ARROW',
		price: 4.99,
		free_trial: '14 Days Free',
		id: 529,
		provider_icon: 'arrow.png',
	},
	{
		clearname: 'Arrow Video Amazon Channel',
		price: 4.99,
		free_trial: '',
		id: 596,
		provider_icon: 'arrow_video_amazon_channel.png',
	},
	{
		clearname: 'Starz Play Amazon Channel',
		price: 4.99,
		free_trial: '',
		id: 194,
		provider_icon: 'starz_play_amazon_channel.png',
	},
	{
		clearname: 'Rakuten TV',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 35,
		provider_icon: 'rakuten_tv.png',
	},
	{
		clearname: 'GuideDoc',
		price: 7.99,
		free_trial: '',
		id: 100,
		provider_icon: 'guidedoc.png',
	},
	{
		clearname: 'Netflix Kids',
		price: 4.99,
		free_trial: '',
		id: 175,
		provider_icon: 'netflix_kids.png',
	},
	{
		clearname: 'YouTube Premium',
		price: 12,
		free_trial: '',
		id: 188,
		provider_icon: 'youtube_premium.png',
	},
	{
		clearname: 'BFI Player Amazon Channel',
		price: 4.99,
		free_trial: '30 Days Free',
		id: 287,
		provider_icon: 'bfi_player_amazon_channel.png',
	},
	{
		clearname: 'Hayu',
		price: 4.99,
		free_trial: '',
		id: 223,
		provider_icon: 'hayu.png',
	},
	{
		clearname: 'Hayu Amazon Channel',
		price: 4.99,
		free_trial: '',
		id: 296,
		provider_icon: 'hayu_amazon_channel.png',
	},
	{
		clearname: 'Sky Sports',
		price: 15.0,
		free_trial: '',
		id: 703,
		provider_icon: 'sky_sports.png',
	},
	{
		clearname: 'BritBox',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 151,
		provider_icon: 'britbox.png',
	},
	{
		clearname: 'BritBox Amazon Channel',
		price: 5.99,
		free_trial: '',
		id: 197,
		provider_icon: 'britbox_amazon_channel.png',
	},
	{
		clearname: 'MUBI Amazon Channel',
		price: 9.99,
		free_trial: '',
		id: 201,
		provider_icon: 'mubi_amazon_channel.png',
	},
	{
		clearname: 'STUDIOCANAL PRESENTS Apple TV Channel',
		price: 4.99,
		free_trial: '',
		id: 1747,
		provider_icon: 'studiocanal_presents_apple_tv_channel.png',
	},
	{
		clearname: 'Curiosity Stream',
		price: 3.95,
		free_trial: '',
		id: 190,
		provider_icon: 'curiosity_stream.png',
	},
	{
		clearname: 'Flix Premiere',
		price: 5.99,
		free_trial: '30 Days Free',
		id: 432,
		provider_icon: 'flix_premiere.png',
	},
	{
		clearname: 'Hotstar',
		price: 5.99,
		free_trial: '',
		id: 122,
		provider_icon: 'hotstar.png',
	},
	{
		clearname: 'Revry',
		price: '',
		free_trial: '',
		id: 473,
		provider_icon: 'revry.png',
	},
	{
		clearname: 'DOCSVILLE',
		price: 3.99,
		free_trial: '3 Days Free',
		id: 475,
		provider_icon: 'docsville.png',
	},
	{
		clearname: 'Now TV',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 39,
		provider_icon: 'now_tv.png',
	},
	{
		clearname: 'MLS Season Pass',
		price: '',
		free_trial: '',
		id: 1851,
		provider_icon: 'mls_season_pass.png',
	},
	{
		clearname: 'WOW Presents Plus',
		price: 3.46,
		free_trial: '',
		id: 547,
		provider_icon: 'wow_presents_plus.png',
	},
	{
		clearname: 'Magellan TV',
		price: '',
		free_trial: '',
		id: 551,
		provider_icon: 'magellan_tv.png',
	},
	{
		clearname: 'BroadwayHD',
		price: 7.99,
		free_trial: '',
		id: 554,
		provider_con: 'broadwayhd.png',
	},
	{
		clearname: 'Acorn TV',
		price: 4.99,
		free_trial: '14 Days Free',
		id: 87,
		provider_icon: 'acorn_tv.png',
	},
	{
		clearname: 'AcornTV Amazon Channel',
		price: '',
		free_trial: '',
		id: 196,
		provider_icon: 'acorntv_amazon_channel.png',
	},
	{
		clearname: 'Dekkoo',
		price: 7.28,
		free_trial: '3 Days Free',
		id: 444,
		provider_icon: 'dekkoo.png',
	},
	{
		clearname: 'True Story',
		price: 5.99,
		free_trial: '',
		id: 567,
		provider_icon: 'true_story.png',
	},
	{
		clearname: 'DocAlliance Films',
		price: 6.0,
		free_trial: '',
		id: 569,
		provider_icon: 'docalliance_films.png',
	},
	{
		clearname: 'Now TV Cinema',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 591,
		provider_icon: 'now_tv_cinema.png',
	},
	{
		clearname: 'CuriosityStream Amazon Channel',
		price: '',
		free_trial: '7 Days Free',
		id: 603,
		provider_icon: 'curiositystream_amazon_channel.png',
	},
	{
		clearname: 'DocuBay Amazon Channel',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 604,
		provider_icon: 'docubay_amazon_channel.png',
	},
	{
		clearname: 'Discovery Plus Amazon Channel',
		price: 4.99,
		free_trial: '',
		id: 584,
		provider_icon: 'discovery_plus_amazon_channel.png',
	},
	{
		clearname: 'DAZN',
		price: '',
		free_trial: '',
		id: 695,
		provider_icon: 'dazn.png',
	},
	{
		clearname: 'Fandor Amazon Channel',
		price: 3.49,
		free_trial: '7 Days Free',
		id: 199,
		provider_icon: 'fandor_amazon_channel.png',
	},
	{
		clearname: 'Full Moon Amazon Channel',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 597,
		provider_icon: 'full_moon_amazon_channel.png',
	},
	{
		clearname: 'ITV Amazon Channel',
		price: 3.99,
		free_trial: '',
		id: 598,
		provider_icon: 'itv_amazon_channel.png',
	},
	{
		clearname: 'MGM Amazon Channel',
		price: 4.49,
		free_trial: '7 Days Free',
		id: 588,
		provider_icon: 'mgm_amazon_channel.png',
	},
	{
		clearname: 'Pokémon Amazon Channel',
		price: 2.99,
		free_trial: '7 Days Free',
		id: 599,
		provider_icon: 'pokémon_amazon_channel.png',
	},
	{
		clearname: 'Shout! Factory Amazon Channel',
		price: 2.99,
		free_trial: '7 Days Free',
		id: 600,
		provider_icon: 'shout!_factory_amazon_channel.png',
	},
	{
		clearname: 'Shudder Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 204,
		provider_icon: 'shudder_amazon_channel.png',
	},
	{
		clearname: 'Eros Now Amazon Channel',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 595,
		provider_icon: 'eros_now_amazon_channel.png',
	},
	{
		clearname: 'FilmBox Live Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 602,
		provider_icon: 'filmbox_live_amazon_channel.png',
	},
	{
		clearname: 'MotorTrend Amazon Channel',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 601,
		provider_icon: 'motortrend_amazon_channel.png',
	},
	{
		clearname: 'Discovery Plus',
		price: 6.99,
		free_trial: '',
		id: 510,
		provider_icon: 'discovery_plus.png',
	},
	{
		clearname: 'ShortsTV Amazon Channel',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 688,
		provider_icon: 'shortstv_amazon_channel.png',
	},
	{
		clearname: 'Cultpix',
		price: '',
		free_trial: '',
		id: 692,
		provider_icon: 'cultpix.png',
	},
	{
		clearname: 'FilmBox Plus',
		price: '',
		free_trial: '',
		id: 701,
		provider_icon: 'filmbox_plus.png',
	},
	{
		clearname: 'Yupp TV',
		price: 19.99,
		free_trial: '',
		id: 255,
		provider_icon: 'yupp_tv.png',
	},
	{
		clearname: 'TNT Sports',
		price: '',
		free_trial: '',
		id: 1839,
		provider_icon: 'tnt_sports.png',
	},
	{
		clearname: 'Paramount Plus Amazon Channel',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 582,
		provider_icon: 'paramount_plus_amazon_channel.png',
	},
	{
		clearname: 'F1TV Pro',
		price: '',
		free_trial: '',
		id: 1720,
		provider_icon: 'f1tv_pro.png',
	},
	{
		clearname: 'Icon Film Amazon Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 1744,
		provider_icon: 'icon_film_amazon_channel.png',
	},
	{
		clearname: 'Curzon Amazon Channel',
		price: 6.99,
		free_trial: '7 Days Free',
		id: 1745,
		provider_icon: 'curzon_amazon_channel.png',
	},
	{
		clearname: 'Hallmark TV Amazon Channel',
		price: 4.49,
		free_trial: '7 Days Free',
		id: 1746,
		provider_icon: 'hallmark_tv_amazon_channel.png',
	},
	{
		clearname: 'Studiocanal Presents Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 1747,
		provider_icon: 'studiocanal_presents_amazon_channel.png',
	},
	{
		clearname: 'Sundance Now Amazon Channel',
		price: 5.99,
		free_trial: '7 Days Free',
		id: 205,
		provider_icon: 'sundance_now_amazon_channel.png',
	},
	{
		clearname: 'Classix',
		price: '',
		free_trial: '',
		id: 445,
		provider_icon: 'classix.png',
	},
	{
		clearname: 'Realeyz Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 1757,
		provider_icon: 'realeyz_amazon_channel.png',
	},
	{
		clearname: 'NFL Game Pass',
		price: '',
		free_trial: '',
		id: 1762,
		provider_icon: 'nfl_game_pass.png',
	},
	{
		clearname: 'Courtside 1891',
		price: '',
		free_trial: '',
		id: 1763,
		provider_icon: 'courtside_1891.png',
	},
	{
		clearname: 'NBA League Pass',
		price: '',
		free_trial: '',
		id: 1761,
		provider_icon: 'nba_league_pass.png',
	},
	{
		clearname: 'Twitch',
		price: '',
		free_trial: '',
		id: 1785,
		provider_icon: 'twitch.png',
	},
	{
		clearname: 'Klassiki',
		price: 9.99,
		free_trial: '7 Days Free',
		id: 1793,
		provider_icon: 'klassiki.png',
	},
	{
		clearname: 'Sun Nxt',
		price: '',
		free_trial: '',
		id: 309,
		provider_icon: 'sun_nxt.png',
	},
	{
		clearname: 'Viaplay',
		price: 14.99,
		free_trial: '',
		id: 76,
		provider_icon: 'viaplay.png',
	},
	{
		clearname: 'Viaplay Sports',
		price: 14.99,
		free_trial: '',
		id: 1795,
		provider_icon: 'viaplay_sports.png',
	},
	{
		clearname: 'Netflix basic with Ads',
		price: 4.99,
		free_trial: '',
		id: 1796,
		provider_icon: 'netflix_basic_with_ads.png',
	},
	{
		clearname: 'Discovery Plus Sport Amazon Channel',
		price: 6.99,
		free_trial: '',
		id: 1835,
		provider_icon: 'discovery_plus_sport_amazon_channel.png',
	},
	{
		clearname: 'Paramount Plus Apple TV Channel',
		price: 6.99,
		free_trial: '',
		id: 1853,
		provider_icon: 'paramount_plus_apple_tv_channel.png',
	},
	{
		clearname: 'Tennis TV',
		price: '',
		free_trial: '',
		id: 1863,
		provider_icon: 'tennis_tv.png',
	},
	{
		clearname: 'WTA TV',
		price: '',
		free_trial: '',
		id: 1864,
		provider_icon: 'wta_tv.png',
	},
	{
		clearname: 'Lionsgate Plus',
		price: '',
		free_trial: '',
		id: 1790,
		provider_icon: 'lionsgate_plus.png',
	},
	{
		clearname: 'OUTtv Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 607,
		provider_icon: 'outtv_amazon_channel.png',
	},
	{
		clearname: 'HistoryPlay Amazon Channel',
		price: 3.99,
		free_trial: '7 Days Free',
		id: 1710,
		provider_icon: 'historyplay_amazon_channel.png',
	},
	{
		clearname: 'Crime Plus Investigation Play Amazon Channel',
		price: 4.99,
		free_trial: '7 Days Free',
		id: 2063,
		provider_icon: 'crime_plus_investigation_play_amazon_channel.png',
	},
	{
		clearname: 'Viaplay Sport Amazon Channel',
		price: 14.99,
		free_trial: '',
		id: 1940,
		provider_icon: 'viaplay_sport_amazon_channel.png',
	},
	{
		clearname: 'DAZN NFL Game Pass',
		price: '',
		free_trial: '',
		id: 1942,
		provider_icon: 'dazn_nfl_game_pass.png',
	},
	{
		clearname: 'Tennis Channel',
		price: '',
		free_trial: '',
		id: 1774,
		provider_icon: 'tennis_channel.png',
	},
	{
		clearname: 'EFL iFollow',
		price: '',
		free_trial: '',
		id: 1949,
		provider_icon: 'efl_ifollow.png',
	},
	{
		clearname: 'EuroLeague TV',
		price: '',
		free_trial: '',
		id: 1952,
		provider_icon: 'euroleague_tv.png',
	},
	{
		clearname: 'Shahid VIP',
		price: 4.49,
		free_trial: '',
		id: 1715,
		provider_icon: 'shahid_vip.png',
	},
	{
		clearname: 'Discovery Plus TNT Sports Amazon Channel',
		price: '',
		free_trial: '',
		id: 1977,
		provider_icon: 'discovery_plus_tnt_sports_amazon_channel.png',
	},
	{
		clearname: 'NFL GamePass on YouTube',
		price: '',
		free_trial: '',
		id: 1982,
		provider_icon: 'nfl_gamepass_on_youtube.png',
	},
	{
		clearname: 'NHL TV',
		price: '',
		free_trial: '',
		id: 1843,
		provider_icon: 'nhl_tv.png',
	},
	{
		clearname: 'Univer Video',
		price: '',
		free_trial: '',
		id: 1860,
		provider_icon: 'univer_video.png',
	},
	{
		clearname: 'LaLiga SportsTV',
		price: '',
		free_trial: '',
		id: 1914,
		provider_icon: 'laliga_sportstv.png',
	},
	{
		clearname: 'TrillerTV Plus',
		price: '',
		free_trial: '',
		id: 1991,
		provider_icon: 'trillertv_plus.png',
	},
	{
		clearname: 'Fanatiz',
		price: '',
		free_trial: '',
		id: 1979,
		provider_icon: 'fanatiz.png',
	},
	{
		clearname: 'Acorn TV Apple TV',
		price: '',
		free_trial: '',
		id: 2034,
		provider_icon: 'acorn_tv_apple_tv.png',
	},
	{
		clearname: 'Tastemade Apple TV Channel',
		price: '',
		free_trial: '',
		id: 2068,
		provider_icon: 'tastemade_apple_tv_channel.png',
	},
	{
		clearname: 'CuriosityStream Apple TV Channel',
		price: '',
		free_trial: '',
		id: 2060,
		provider_icon: 'curiositystream_apple_tv_channel.png',
	},
	{
		clearname: 'BFI Player Apple TV Channel',
		price: 4.99,
		free_trial: '',
		id: 2041,
		provider_icon: 'bfi_player_apple_tv_channel.png',
	},
	{
		clearname: 'BTV',
		price: '',
		free_trial: '',
		id: 1871,
		provider_icon: 'btv.png',
	},
	{
		clearname: 'Kocowa',
		price: '',
		free_trial: '',
		id: 464,
		provider_icon: 'kocowa.png',
	},
	{
		clearname: 'Sky Store',
		price: '',
		free_trial: '',
		id: 130,
		provider_icon: 'sky_store.png',
	},
	{
		clearname: 'Amazon Prime Video with Ads',
		price: '5.99',
		free_trial: '',
		id: 2100,
		provider_icon: 'amazon_prime_video_with_ads.png',
	},
];
